// Future people, consider the use of LazyTooltip instead. It is lazy bound
// and would be only instantiated on hover.
import React, {memo} from 'react';

import {type Placement} from 'popper.js';
import {Tooltip} from 'reactstrap';

import {AttachOverlay} from 'app/general/overlays/AttachOverlay';

import type {AttachOverlayChildProps} from 'app/general/overlays/AttachOverlay';
type Props = {
  tooltipContent: React.ReactNode;
  children: (props: AttachOverlayChildProps) => any;
  trigger?: string;
  placement?: Placement;
  tooltipClass?: string;
};
export const AttachTooltip = memo<Props>(
  ({
    tooltipContent,
    tooltipClass = '',
    trigger = 'hover focus',
    children,
    placement = 'auto',
  }: Props) => (
    <AttachOverlay
      trigger={trigger}
      overlay={(props) => (
        <Tooltip
          className={tooltipClass}
          placement={placement}
          {...props.overlayProps}
        >
          {tooltipContent}
        </Tooltip>
      )}
    >
      {children}
    </AttachOverlay>
  )
);
